import { api } from "./api";

const productApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProduct: builder.query({
      query: () => "products",
      providesTags: ["products"],
    }),
    addProduct: builder.mutation({
      query: (newCategory) => ({
        url: "products",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["products"],
    }),
    removeProduct: builder.mutation({
      query: (id) => ({
        url: `products/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["products"],
    }),
    editProduct: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `/products/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["products"],
    }),
  }),
});

export const {
  useGetProductQuery,
  useAddProductMutation,
  useRemoveProductMutation,
  useEditProductMutation,
} = productApi;
